import http from './http'
import { TApi } from './const'

/**
 * Kursvideos zu Bunny Stream hochladen.
 *
 * Das Video geht aus dem Browser **direkt** zu Bunny (TUS-Protokoll), nicht
 * über unseren Server: Dort nimmt nginx höchstens rund 10 MB je Anfrage, und
 * ein Video in voller Qualität hat mehrere Hundert. Der Server gibt nur die
 * Freigabe (eine Signatur, zwei Stunden gültig) und erfährt am Ende, welches
 * Video zur Lektion gehört — so zeigt die Lektion bis dahin weiter das alte.
 *
 * Ist Bunny am Server nicht eingerichtet (`media-settings` → `bunny: false`),
 * bleibt der bisherige Weg in Stücken über den eigenen Server
 * (`uploadInChunks` in shared/courses).
 */

let einstellungen = null

/** Ob der Server Bunny eingerichtet hat — einmal je Sitzung gefragt. */
export const loadMediaSettings = () => {
	if (!einstellungen) {
		einstellungen = http
			.get(TApi.ADMIN_COURSES_MEDIA_SETTINGS, { disableToast: true })
			.then(({ data }) => ({ bunny: data?.bunny === true }))
			.catch(() => {
				einstellungen = null
				return { bunny: false }
			})
	}
	return einstellungen
}

/** Nur für Tests: die gemerkte Antwort vergessen. */
export const resetMediaSettings = () => {
	einstellungen = null
}

/**
 * @param file      das Video (File)
 * @param duration  Laufzeit in Sekunden, im Browser gemessen
 * @param start     () => Promise<{endpoint, libraryId, videoId, expires, signature}>
 * @param finish    ({guid, duration}) => Promise<Antwort des Servers>
 * @param Upload    die Klasse aus tus-js-client (austauschbar für Tests)
 */
export const uploadToBunny = async ({ file, duration, start, finish, Upload, onProgress = () => {} }) => {
	const freigabe = await start()

	await new Promise((fertig, fehler) => {
		const upload = new Upload(file, {
			endpoint: freigabe.endpoint,
			// Kurze Aussetzer im Schul- oder Büro-WLAN nicht gleich als Fehler werten.
			retryDelays: [0, 3000, 10000, 30000],
			headers: {
				AuthorizationSignature: freigabe.signature,
				AuthorizationExpire: String(freigabe.expires),
				VideoId: freigabe.videoId,
				LibraryId: String(freigabe.libraryId)
			},
			metadata: {
				filetype: file.type || 'video/mp4',
				title: file.name || 'video.mp4'
			},
			onProgress: (gesendet, gesamt) => onProgress(gesamt ? Math.round((gesendet / gesamt) * 100) : 0),
			onError: fehler,
			onSuccess: fertig
		})
		upload.start()
	})

	onProgress(100)
	return finish({ guid: freigabe.videoId, duration })
}
